'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit() {
    _classCallCheck(this, Edit);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Edit.prototype.componentDidMount = function componentDidMount() {
    var initCallback = this.props.initCallback;

    initCallback && initCallback();
  };

  Edit.prototype.render = function render() {
    var _props = this.props,
        owner = _props.owner,
        children = _props.children,
        subStates = _props.subStates;

    var childElms = children ? children.map(function (child) {
      var componentSchema = JSON.parse(JSON.stringify(child.props.componentSchema));
      // const componentSchema = cloneDeep(child.props.componentSchema);
      componentSchema.props.fieldId = owner.getValue('fieldId') + '>' + componentSchema.props.fieldId;
      // 编辑的时候展示所有列
      componentSchema.props.visible = true;

      return _react2.default.cloneElement(child, _extends({}, child.props, {
        componentSchema: componentSchema,
        isChildComponent: true,
        disableFieldSelect: true, // 卡片禁用子组件的表单项选择模式，服务端不支持
        enableInputBalloon: false // 禁止Input子组件开启气泡提示
      }));
    }) : [];
    return _react2.default.createElement(
      'div',
      { className: 'vc-big-table-edit-form', style: { height: 30 * childElms.length + 200 } },
      childElms
    );
  };

  return Edit;
}(_react.Component);

exports.default = Edit;
module.exports = exports['default'];